<script>
/*jshint esversion: 6 */
export default {
    name: 'MyHeadline',
    props: {
        'model': Object,
        'schema': Object,
        'schemaId':Number,
        'hinted': String,
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .fieldHeadline(:id="schemaId")
        template(v-if="schema.size === 'h1'")
            h1(:class="schema.class" v-html="schema.text") 
        template(v-if="schema.size === 'h2'")
            h2(:class="schema.class" v-html="schema.text") 
        template(v-if="schema.size === 'h3'")
            h3(:class="schema.class" v-html="schema.text") 
        template(v-if="schema.size === 'h4'")
            h4(:class="schema.class" v-html="schema.text") 
        template(v-if="schema.size === 'h5'")
            h5(:class="schema.class" v-html="schema.text") 
        .hint(v-if="hinted && hinted.length > 0" v-html="hinted") 
</template>